import CustomButton from "@/components/CustomButton";
import { useNavigate, useParams } from "react-router";

export default function NoUPMessage() {
  const navigate = useNavigate();
  const { id } = useParams();

  return (
    <div className="flex items-center justify-center">
      <div className="flex flex-col gap-4">
        <span className="text-lg">Please create unique possibilities to proceed.</span>
        <CustomButton
          onClickHandler={() => navigate(`/household/${id}/unique-possibilities`)}
          className="w-max"
          text="Create unique possibilities"
        />
      </div>
    </div>
  );
}
